import { mountButton } from '../../../components/Button.component';
import {
    CONTAINER_BUTTON_PRINT_TO_PDF,
    CONTAINER_BUTTON_SEND_FORM,
    CONTAINER_NOTE,
    CONTAINER_FIRST_NAME,
    CONTAINER_LAST_NAME,
    CONTAINER_STREET,
    CONTAINER_HOUSE_NUMBER,
    CONTAINER_POSTAL_CODE,
    CONTAINER_CITY,
    CONTAINER_EMAIL,
    CONTAINER_CUSTOMER_NUMBER,
    CONTAINER_CONTRACT_NUMBER,
    CONTAINER_TERMINATION_DATE,
    VALUE_SEND_FORM_BUTTON,
    CONTAINER_CAPTCHA_REFRESH,
    CONTAINER_CAPTCHA_AUDIO,
    HEADER_AUDIO,
    CONTAINER_CAPTCHA_RESULT,
    BUTTON_ICON_PLAY,
    BUTTON_TEXT_PRINT,
    BUTTON_ICON_REFRESH,
    BUTTON_EVENT_CLICK,
    BUTTON_ICON_DOWNLOAD,
} from '../constant';
import { mountFormElement } from '../../../components/FormElement.component';
import {
    formValidation,
    IFormFieldElement,
} from '@vfde-brix/ws10/validation';
import {
    DATE_FORMAT,
    EMAIL_FORMAT,
    MAX_LENGTH_50,
    MAX_LENGTH_70,
    ONLY_NUMBERS,
    PAST_DATE,
} from './validators.helper';
import { mountButtonIconOnly } from '../../../components/ButtonIconOnly.component';
import { IFormElements } from '../interface';
import { ActionDispatchers } from '../action';
import { BUTTON_ICON_POSITION_LEFT } from '@vfde-brix/ws10/button';

/**
 * mounting every form element here
 * to keep index.ts transparent and simple
 */
export const mountAndValidateFormElements = (getCaptchaAction: ActionDispatchers['getCaptcha']): IFormElements | null => {
    const sendBtn = mountButton(CONTAINER_BUTTON_SEND_FORM, { stdContent: VALUE_SEND_FORM_BUTTON });
    const refreshBtn = mountButtonIconOnly(CONTAINER_CAPTCHA_REFRESH, { stdIconName: BUTTON_ICON_REFRESH });
    mountButton(
        CONTAINER_BUTTON_PRINT_TO_PDF,
        {
            stdContent: BUTTON_TEXT_PRINT,
            icon: {
                optPosition: BUTTON_ICON_POSITION_LEFT,
                stdIconName: BUTTON_ICON_DOWNLOAD,
            },
            onClick: () => window.print(),
        },
    );

    // must be a regular function to take advantage of the this / event.currentTarget reference
    function listener (event: Event) {
        getCaptchaAction(HEADER_AUDIO);
        event.currentTarget?.removeEventListener(BUTTON_EVENT_CLICK, listener);
    }

    const playBtn = mountButtonIconOnly(CONTAINER_CAPTCHA_AUDIO, { stdIconName: BUTTON_ICON_PLAY, onClick: listener });
    // mount form elements in a loop where the validator is the same
    const formFieldContainers = [
        CONTAINER_FIRST_NAME,
        CONTAINER_LAST_NAME,
        CONTAINER_STREET,
        CONTAINER_HOUSE_NUMBER,
        CONTAINER_POSTAL_CODE,
        CONTAINER_CITY,
    ];
    const formFields: IFormFieldElement[] = [];
    formFieldContainers.forEach(container => {
        const field = mountFormElement(container, [MAX_LENGTH_50]);

        if (field !== null) {
            formFields.push(field);
        }
    });

    [
        mountFormElement(CONTAINER_EMAIL, [EMAIL_FORMAT]),
        mountFormElement(CONTAINER_CUSTOMER_NUMBER, [MAX_LENGTH_70, ONLY_NUMBERS]),
        mountFormElement(CONTAINER_CONTRACT_NUMBER, [MAX_LENGTH_70, ONLY_NUMBERS]),
        mountFormElement(CONTAINER_TERMINATION_DATE, [MAX_LENGTH_50, DATE_FORMAT, PAST_DATE]),
        mountFormElement(CONTAINER_NOTE, []),
    ].filter(field => field !== null).forEach(field => formFields.push(field!));

    const captchaInput = mountFormElement(CONTAINER_CAPTCHA_RESULT, []);
    captchaInput && formFields.push(captchaInput);

    formValidation({ formFields }, false);

    let formElements: IFormElements = {};

    if (sendBtn !== null) {
        formElements = { ...formElements, sendBtn };
    }

    if (playBtn !== null) {
        formElements = { ...formElements, playBtn };
    }

    if (captchaInput !== null) {
        formElements = { ...formElements, captchaInput };
    }

    if (refreshBtn !== null) {
        formElements = { ...formElements, refreshBtn };
    }

    return Object.keys(formElements).length > 0 ? formElements : null;
};
